import { TrendingDown, Eye, Scale, ClipboardCheck } from "lucide-react";

export default function WhyMatters() {
  return (
    <section data-testid="why-matters" className="relative py-20 lg:py-28 border-t border-black/[0.05]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2b2620]">Warum es zählt</div>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#2b2620]">
              Ihr Ruf ist Ihr Kapital.
            </h2>
          </div>
          <p className="text-[#6b5f52] leading-relaxed lg:max-w-md">
            Eine einzige Bewertung kann darüber entscheiden, ob sich ein potenzieller Kunde für oder gegen Ihr Unternehmen entscheidet. Genau deshalb lohnt sich Hinschauen – und im richtigen Moment Handeln.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-5">
          <div
            data-testid="why-card-1"
            className="md:col-span-4 relative overflow-hidden bg-[#faf6ef] border border-black/[0.08] rounded-3xl p-8 lg:p-10 group hover:border-[#2b2620]/30 transition-all"
          >
            <div className="absolute inset-0 -z-10 opacity-30">
              <div className="absolute -bottom-32 -right-32 w-[400px] h-[400px] rounded-full bg-[#2b2620]/20 blur-[120px]" />
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#2b2620]/10 border border-[#2b2620]/30 flex items-center justify-center text-[#2b2620]">
                <Eye className="w-5 h-5" />
              </div>
              <span className="text-xs uppercase tracking-[0.2em] text-[#8a7f70]">01</span>
            </div>
            <h3 className="mt-6 font-heading text-2xl sm:text-3xl font-medium text-[#2b2620]">
              Vertrauen entsteht oder verschwindet in Sekunden.
            </h3>
            <p className="mt-4 text-[#6b5f52] max-w-lg leading-relaxed">
              Viele Kunden entscheiden in unter 10 Sekunden – oft allein auf Basis öffentlicher Bewertungen. Eine einzige unfaire Stimme kann ausreichen, um Zweifel zu säen.
            </p>
          </div>

          <div
            data-testid="why-card-2"
            className="md:col-span-2 bg-[#faf6ef] border border-black/[0.08] rounded-3xl p-8 hover:border-[#2b2620]/30 transition-all"
          >
            <div className="w-10 h-10 rounded-lg bg-[#2b2620]/10 border border-[#2b2620]/30 flex items-center justify-center text-[#2b2620]">
              <TrendingDown className="w-5 h-5" />
            </div>
            <div className="mt-6 text-3xl font-heading font-semibold gold-text">88%</div>
            <p className="mt-2 text-sm text-[#6b5f52] leading-relaxed">
              der Konsumenten lesen Online-Bewertungen, bevor sie einem Unternehmen vertrauen.
            </p>
          </div>

          <div
            data-testid="why-card-3"
            className="md:col-span-2 bg-[#faf6ef] border border-black/[0.08] rounded-3xl p-8 hover:border-[#2b2620]/30 transition-all"
          >
            <div className="w-10 h-10 rounded-lg bg-[#2b2620]/10 border border-[#2b2620]/30 flex items-center justify-center text-[#2b2620]">
              <Scale className="w-5 h-5" />
            </div>
            <h3 className="mt-6 font-heading text-lg font-medium text-[#2b2620]">Nicht jede Bewertung ist gerechtfertigt</h3>
            <p className="mt-3 text-sm text-[#6b5f52] leading-relaxed">
              Manche Bewertungen entsprechen schlicht nicht der Realität oder verstoßen gegen die Plattform-Richtlinien.
            </p>
          </div>

          <div
            data-testid="why-card-4"
            className="md:col-span-4 bg-[#faf6ef] border border-black/[0.08] rounded-3xl p-8 lg:p-10 hover:border-[#2b2620]/30 transition-all"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#2b2620]/10 border border-[#2b2620]/30 flex items-center justify-center text-[#2b2620]">
                <ClipboardCheck className="w-5 h-5" />
              </div>
              <span className="text-xs uppercase tracking-[0.2em] text-[#8a7f70]">04</span>
            </div>
            <h3 className="mt-6 font-heading text-2xl font-medium text-[#2b2620]">
              Strukturierte Meldungen erhöhen die Chance auf eine Prüfung.
            </h3>
            <p className="mt-4 text-[#6b5f52] max-w-2xl leading-relaxed">
              Wenn eine Bewertung sauber aufbereitet und nachvollziehbar über das offizielle Formular eingereicht wird, steigen die Chancen auf eine Prüfung deutlich – ohne übertriebene Versprechen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
